import { useCallback, useState } from 'react'

export default function useLocalStorage<T>(keyName: string, defaultValue: T): [T, React.Dispatch<T>] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const value = window.localStorage.getItem(keyName)

      if (value) {
        return JSON.parse(value)
      }

      window.localStorage.setItem(keyName, JSON.stringify(defaultValue))

      return defaultValue
    } catch (_err) {
      return defaultValue
    }
  })

  const setValue = useCallback(
    (newValue: T): void => {
      try {
        window.localStorage.setItem(keyName, JSON.stringify(newValue))
      } catch (_err) {
        return setStoredValue(newValue)
      }

      setStoredValue(newValue)
    },
    [keyName],
  )

  return [storedValue, setValue]
}
